<template>
	<div :class="{ 'has-logo': showLogo }" class="flex-x">
		<!-- <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar> -->
		<el-scrollbar class="menu" wrap-class="scrollbar-wrapper">
			<sidebar-left
				v-for="route in permission_routes"
				:key="route.path"
				:item="route"
				:base-path="route.path"
				:leftSelect="leftSelect"
				@click="change"
			/>
		</el-scrollbar>
		<el-scrollbar class="son_scroll" wrap-class="scrollbar-wrapper">
			<sidebar-item
				v-for="route in children"
				:key="route.path || route.id"
				:item="route"
				:base-path="leftSelect"
			/>
		</el-scrollbar>
	</div>
</template>

<script>
import path from 'path'
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import SidebarLeft from './SidebarLeft'
import variables from '@/styles/variables.scss'
import { generateTitle } from '@/utils/i18n'

import { isExternal } from '@/utils/validate'
export default {
	components: { SidebarItem, SidebarLeft },
	data () {
		return {
			leftSelect: '',
			children: []
		}
	},
	created () {
		const route = this.permission_routes.filter((v) => {
			return !v.hidden
		})
		if (!route.length) {
			this.$router.push({ path: '/404' })
			return
		}
		const matchedRoute = this.$route.matched
		const storageNav = localStorage.getItem('nav1')

		if (matchedRoute && matchedRoute.length && matchedRoute[0].path && route.some(({ path }) => path == matchedRoute[0].path)) {
			this.leftSelect = matchedRoute[0].path
		} else if (storageNav && route.some(({ path }) => path == storageNav)) {
			this.leftSelect = storageNav
		} else {
			this.leftSelect = route[0].path
		}

		const data = route.find(({ path }) => path == this.leftSelect)
		this.$set(this, 'children', data.children)
	},
	computed: {
		...mapGetters(['permission_routes', 'sidebar']),
		activeMenu () {
			const route = this.$route
			const { meta, path } = route
			// if set path, the sidebar will highlight the path you set
			if (meta.activeMenu) {
				return meta.activeMenu
			}
			return path
		},
		showLogo () {
			return this.$store.state.settings.sidebarLogo
		},
		variables () {
			return variables
		},
		isCollapse () {
			return !this.sidebar.opened
		}
	},
	// mounted() {
	// 	this.item = this.permission_routes.filter((v) => {
	// 		return !v.hidden;
	// 	})[0];
	// },
	methods: {
		resolvePath (routePath) {
			if (isExternal(routePath)) {
				return routePath
			}
			if (isExternal(this.leftSelect)) {
				return this.leftSelect
			}
			return path.resolve(this.leftSelect, routePath)
		},
		generateTitle,
		change (item) {
			this.leftSelect = item.path
			localStorage.setItem('nav1', item.path)
			this.children = item.children
		}
	}
}
</script>
<style lang="scss" scoped>
.menu {
	width: 80px;
	background: #304156;
	height: 100%;
	color: rgb(191, 203, 217);
	border-top: 1px solid rgb(219, 219, 219);
	.item {
		height: 50px;
		line-height: 50px;
	}
}
.son_scroll {
	width: 120px;
	height: 100%;
	border-top: 1px solid rgb(219, 219, 219);
	/deep/ {
		.el-scrollbar__bar.is-vertical {
			width: 2px;
		}
		.el-menu-item {
			background-color: #fff;
			color: #515a6e;
			display: flex;

			align-items: center;
			justify-content: center;
			a {
				text-align: left;
				padding: 0 10px;
				text-overflow: ellipsis;
			}
			.router-link-active {
				color: #409eff;
				background: #e7f0fa;
				&::after {
					content: "";
					display: block;
					width: 3px;
					position: absolute;
					top: 0;
					bottom: 0;
					right: 0;
					background: #409eff;
				}
			}
		}
		.title {
			display: block;
			color: #999;
			text-indent: 10px;
			font-weight: normal;
			cursor: initial;
		}
		.child {
			.el-menu-item {
				color: #515a6e;
				text-indent: 10px;
				height: 38px !important;
				line-height: 38px !important;
			}
		}
	}
}
/deep/ {
	.el-menu-item,
	.el-submenu__title {
		padding: 0 5px;
		padding-left: 0 !important;
	}
	.el-menu-item {
		color: rgb(191, 203, 217);
		background-color: rgb(48, 65, 86);
		font-size: 12px;
		height: 42px;
		line-height: 42px;
		padding: 0;
		&.title {
			font-weight: bold;
			background: #f5f5f5;
		}
	}
	.el-menu--inline {
		position: absolute;
		left: 80px;
		top: 0;
		width: 120px !important;
		transition: 0s;
	}
}
.flex-x {
	box-shadow: 2px 0 6px rgba(0,21,41,0.35)!important;
	z-index: 999;
}
</style>
